export const feedbacksInitialState = {
    questions: null,
    isLoading: true,
}